import { Icon } from '@pfida-finance/ui/components';
import type { CSSProperties } from 'react';

type Props = {
  onClick: () => void;
  style?: CSSProperties;
  label?: string;
};

export function InfoButton({ onClick, style, label = 'How is this calculated?' }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center justify-center w-4 h-4 ml-1 text-gray-400 hover:text-[#4b3e6d] transition-colors flex-shrink-0"
      style={style}
      aria-label={label}
    >
      <Icon name="info" className="w-4 h-4" />
    </button>
  );
}
